import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef } from 'react';
import '../IconButton/fa92464f43077b1cbdd0bb416ee549d83eadaee9906eab0987bbf0ad889eddad.cfe-internal.js';
import '../../icons/index.es.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import styles from './4c4b7142c6b26bf0990bbc3824153eb7c4ab45a946d1bb0612dc81b46e40bfa3.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import IconButton from '../IconButton/399631eebecc03da030561fb1a25c35c2d29c5e4645700b7fca3cf592ca75904.cfe-internal.js';
import SearchIcon from '../../icons/components/fd44f420e4f0cf097c788b0db805e5b1767bfe0b6caaa7e8803b476a89e57dbc.cfe-internal.js';

var _excluded = ["tooltipContent", "tooltipPlacement"];
var CollapsibleSearchInputIconButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var tooltipContent = _ref.tooltipContent,
    _ref$tooltipPlacement = _ref.tooltipPlacement,
    tooltipPlacement = _ref$tooltipPlacement === void 0 ? 'bottom' : _ref$tooltipPlacement,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var label = translate('collapsibleSearchInput.openSearchField');
  return /*#__PURE__*/React__default.createElement(IconButton, _extends({}, rest, {
    className: styles.iconButton,
    "aria-label": label,
    tooltipContent: tooltipContent !== null && tooltipContent !== void 0 ? tooltipContent : label,
    tooltipPlacement: tooltipPlacement,
    ref: ref
  }), /*#__PURE__*/React__default.createElement(SearchIcon, null));
});

export { CollapsibleSearchInputIconButton as default };
